import { HttpService } from "@root/services/http";
import {
  CREATE_PRESENTATION_ENDPOINT,
  GET_TEMPLATES_ENDPOINT,
} from "./endpoints";

export class PresentationService extends HttpService {
  createPresentation = async (
    baseAuthUrl: string,
    payload: any
  ): Promise<any> => {
    const baseUrl = `${baseAuthUrl}/${CREATE_PRESENTATION_ENDPOINT}`;
    try {
      const apiResponse = await this.post(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  getThemes = async (baseAuthUrl: string): Promise<any> => {
    const baseUrl = `${baseAuthUrl}/${GET_TEMPLATES_ENDPOINT}`;
    try {
      const apiResponse = await this.get(baseUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
}
